import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, FloorLabel } from "../motion/Reveal";
import { CompanyLogo } from "../brand/CompanyLogo";
import { isEn, t } from "../../lib/i18n";

const WORDS = isEn
  ? ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve"]
  : ["null", "ett", "to", "tre", "fire", "fem", "seks", "sju", "åtte", "ni", "ti", "elleve", "tolv"];

/**
 * The portfolio as a hairline lattice: ten cells, one official logo each, monochrome at rest.
 * Hover / focus fills the cell navy, swaps to the white logo and reveals name and location.
 */
export const CompaniesFloor = ({ companies = [] }) => {
  const count = WORDS[companies.length] || companies.length;
  return (
    <section data-testid="floor-selskaper" className="bg-surface">
      <div className="wrap floor">
        <Reveal className="grid-12 gap-y-6 items-end">
          <div className="col-span-12 lg:col-span-7">
            <FloorLabel>{t("Selskapene")}</FloorLabel>
            <h2 className="mt-4 t-h2 max-w-[16ch]"><span className="capitalize">{count}</span> {t("selskaper. Ett EQVA.")}</h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="t-body text-muted max-w-[40ch]">{t("Egne navn. Egen ledelse. Sterk lokal forankring. Sammen utgjør de EQVA.")}</p>
            <Link to="/selskaper" data-testid="companies-see-all" className="link-arrow mt-5 t-small">{t("Møt selskapene")} <ArrowRight size={16} /></Link>
          </div>
        </Reveal>

        <Reveal delay={100} as="ol" data-testid="companies-index" className="logo-grid mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5" aria-label={t("Selskapene i EQVA")}>
          {companies.map((c, i) => (
            <li key={c.slug}>
              <Link to={`/selskaper/${c.slug}`} data-testid={`subsidiary-wordmark-${i}`} className="logo-cell group" aria-label={`${c.name}, ${c.location || ""}`.trim()}>
                <span className="logo-cell-index tabular">{String(i + 1).padStart(2, "0")}</span>
                <ArrowUpRight size={16} strokeWidth={1.5} className="logo-cell-arrow" aria-hidden="true" />
                <span className="logo-cell-logo">
                  <CompanyLogo company={c} swap swapTo="white" height={34} className="max-w-full" />
                </span>
                <span className="logo-cell-meta" aria-hidden="true">
                  <span className="block truncate font-medium">{c.name}</span>
                  <span className="block truncate">{c.location}</span>
                </span>
              </Link>
            </li>
          ))}
        </Reveal>
      </div>
    </section>
  );
};
